"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this function has been moved to a module so we can mock it
exports.default = (function (path) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return __non_webpack_require__(path);
});
